import { render, staticRenderFns } from "./DosesSummaryregionUnit.vue?vue&type=template&id=44fe588c&"
import script from "./DosesSummaryregionUnit.vue?vue&type=script&lang=js&"
export * from "./DosesSummaryregionUnit.vue?vue&type=script&lang=js&"
import style0 from "./DosesSummaryregionUnit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports